// eslint-disable-next-line no-restricted-imports
import { Skeleton as SkeletonMUI, styled } from '@mui/material';

export type SkeletonProps = {
  height: number | string;
  borderRadius?: number;
  margin?: string;
  width?: number | string | 'auto';
  flex?: number;
  variant?: 'light';
  className?: string;
};

const StyledSkeleton = styled(SkeletonMUI)<{ isLight?: boolean }>(
  ({ theme, isLight }) => ({
    margin: `${theme.spacing(2)} 0`,
    transform: 'none',
    flex: '0 0 auto',
    backgroundColor: isLight
      ? 'var(--background-background-color)'
      : 'var(--input-input-background-color)',
  })
);

export const Skeleton = ({
  height,
  width,
  borderRadius,
  margin,
  flex,
  variant,
  className,
}: SkeletonProps) => {
  return (
    <StyledSkeleton
      className={className}
      isLight={variant === 'light'}
      animation="wave"
      sx={(theme) => ({
        flex,
        height,
        width: width || '100%',
        borderRadius: theme.spacing(
          typeof borderRadius === 'undefined' ? 2 : borderRadius
        ),
        margin: margin || `${theme.spacing(2)} 0`,
      })}
    />
  );
};
